export default "__VITE_ASSET__7d9ae344__"